export default __webpack_public_path__ + "static/media/Onur.868a76cf.jpeg";